export default "__VITE_ASSET__f04beda4__"